import { render, staticRenderFns } from "./roll-number.vue?vue&type=template&id=7519555c"
import script from "./roll-number.vue?vue&type=script&lang=js"
export * from "./roll-number.vue?vue&type=script&lang=js"
import style0 from "./roll-number.vue?vue&type=style&index=0&id=7519555c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports